<span class="badge badge-pessoa-tipo badge-pessoa-tipo-juridica">
    {{tipo.nome}}
</span>